import theme from '@adsk/alloy-react-theme';

export const errorSectionStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  paddingTop: '48px',
};

export const errorTitleStyle = {
  ...theme.typography.heading2,
  textAlign: 'center',
};

export const tryAgainLinkStyle = {
  paddingTop: '20px',
};
